import userSegmentTypes from '../../consts/loyalty/userSegmentTypes';
import answerTypes from '../../consts/loyalty/userSurveyAnswerTypes';
import {selectLoyaltyUserData} from '../../state/selectors/loyalty';
import {getState} from '../../state/store';

const CONFIG = [
    {answers: [answerTypes.SOURCING_CC], type: userSegmentTypes.CC},
    {answers: [answerTypes.SOURCING_COMP_HNB], type: userSegmentTypes.COMP_HNB},
    {answers: [answerTypes.SOURCING_CC, answerTypes.SOURCING_EVAPOR], type: userSegmentTypes.EVAPE_DUAL},
    {answers: [answerTypes.SOURCING_CC, answerTypes.SOURCING_COMP_HNB], type: userSegmentTypes.EVAPE_DUAL},
    {
        answers: [answerTypes.SOURCING_CC, answerTypes.SOURCING_EVAPOR, answerTypes.SOURCING_COMP_HNB],
        type: userSegmentTypes.EVAPE_DUAL,
    },
    {
        answers: [answerTypes.SOURCING_CC, answerTypes.SOURCING_EVAPOR, answerTypes.SOURCING_POUCHES],
        type: userSegmentTypes.EVAPE_DUAL,
    },
    {
        answers: [answerTypes.SOURCING_CC, answerTypes.SOURCING_COMP_HNB, answerTypes.SOURCING_POUCHES],
        type: userSegmentTypes.EVAPE_DUAL,
    },
    {
        answers: [
            answerTypes.SOURCING_CC,
            answerTypes.SOURCING_EVAPOR,
            answerTypes.SOURCING_COMP_HNB,
            answerTypes.SOURCING_POUCHES,
        ],
        type: userSegmentTypes.EVAPE_DUAL,
    },
    {
        answers: [answerTypes.SOURCING_CC, answerTypes.SOURCING_POUCHES],
        type: userSegmentTypes.POLY_HNB,
    },
    {
        answers: [answerTypes.SOURCING_EVAPOR, answerTypes.SOURCING_COMP_HNB],
        type: userSegmentTypes.POLY_HNB,
    },
    {
        answers: [answerTypes.SOURCING_COMP_HNB, answerTypes.SOURCING_POUCHES],
        type: userSegmentTypes.POLY_HNB,
    },
    {
        answers: [answerTypes.SOURCING_EVAPOR, answerTypes.SOURCING_COMP_HNB, answerTypes.SOURCING_POUCHES],
        type: userSegmentTypes.POLY_HNB,
    },
];

const getSourcingTypeByAnswers = (answers) => {
    if (!Array.isArray(answers)) return [];

    const normalize = (arr) => [...arr].sort().join('|');

    const normalizedAnswers = normalize(answers);

    return CONFIG.filter((item) => normalize(item.answers) === normalizedAnswers).map((item) => item.type);
};

const getUserSegmentTypes = () => {
    const {sourcing = [], reason, motivation, userSegment} = selectLoyaltyUserData(getState());

    return [...sourcing, reason, motivation, userSegment];
};

const mapUserSegmentTypes = (data) => {
    const {sourcing = [], ...rest} = data;

    const sourcingTypes = getSourcingTypeByAnswers(sourcing);

    return {sourcing: sourcingTypes, ...rest};
};

export default {
    getSourcingTypeByAnswers,
    mapUserSegmentTypes,
    getUserSegmentTypes,
};
